import styled from "styled-components/macro";

export const horizontalPadding = "1.6rem";

export const StyledWrapper = styled.div`
  padding: 0 ${horizontalPadding};
  margin: auto;
  max-width: 1200px;
`;
